(function (Cobalt) {
    var $ = jQuery;
    var Burger = /** @class */ (function () {
        function Burger() {
        }
        Burger.initializeEarly = function () {
            this.Html = $('html');
            this.MenuButton = $('<i>');
            this.SearchButton = $('<i>');
            this.Body = $('body');
            this.Header = $('header.main');
            this.Nav = $('nav.main');
            this.Netbar = $('div#netbar');
            this.SiteContainer = $('div.container');
            this.SubNavLink = $('nav.p-nav-a li.section > a');
            this.SiteOverlay = $('<div class="site-overlay">');
            this.Window = $(window);
            if (!this.Body.hasClass('responsive-enabled')) {
                return;
            }
            if (this.Body.css('border-style') == 'double') {
                Burger.Body.addClass('burger-ready');
            }
            this.grillBurger();
            this.bindEvents();
        };
        Burger.grillBurger = function () {
            this.MenuButton.addClass('menu-button').appendTo(this.Header);
            this.SearchButton.addClass('search-button').insertAfter(this.MenuButton);
            this.SiteOverlay.appendTo(this.Body);
        };
        Burger.bindEvents = function () {
            this.SubNavLink.on('click', this.getEventHandler('navItemClick'));
            this.MenuButton.on('click', this.getEventHandler('menuClick'));
            this.SiteOverlay.on('click', this.getEventHandler('closeMenu'));
            this.SearchButton.on('click', this.getEventHandler('searchClick'));
            this.Window.on('resize', this.getEventHandler('windowResize'));
        };
        Burger.getEventHandler = function (event) {
            var _this = this;
            if (event && this.EventHandlers[event] !== undefined) {
                return function () {
                    var args = Array.prototype.slice.call(arguments, 0);
                    args.unshift($(this));
                    _this.EventHandlers[event].apply(_this, args);
                };
            }
        };
        Burger.Resize = function ($this, event) {
            if (Burger.Body.css('border-style') == 'double' && !Burger.Body.hasClass('burger-ready')) {
                setTimeout(function () {
                    Burger.Body.addClass('burger-ready');
                }, 50);
            }
            else if (Burger.Body.css('border-style') != 'double') {
                Burger.Body.removeClass('burger-ready');
            }
        };
        Burger.EventHandlers = {
            windowResize: function ($this, event) {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(function () { Burger.Resize($this, event); }, 1000);
            },
            menuClick: function ($this, event) {
                if (!this.Body.hasClass('burger-open')) {
                    this.Body.addClass('burger-open');
                    this.Body.removeClass('search-open');
                }
                else {
                    this.Body.removeClass('burger-open');
                }
            },
            closeMenu: function ($this, event) {
                this.Body.removeClass('burger-open');
            },
            navItemClick: function ($this, event) {
                var subNavSection = $this.parent();
                if (this.Html.hasClass('mobile') || ($('body').hasClass('responsive-enabled') && this.Window.innerWidth() < 1024)) {
                    event.preventDefault();
                }
                if (subNavSection.hasClass('section') && subNavSection.hasClass('subnav-open') == false) {
                    subNavSection.addClass('subnav-open');
                }
                else {
                    subNavSection.removeClass('subnav-open');
                }
            },
            searchClick: function ($this, event) {
                if (!this.Body.hasClass('search-open')) {
                    this.Body.addClass('search-open');
                }
                else {
                    this.Body.removeClass('search-open');
                }
            }
        };
        return Burger;
    }());
    Cobalt.Burger = Burger;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Burger.js